import app from 'flarum/common/app';
app.initializers.add('glowingblue-demo-common', () => {
  console.log('[glowingblue/demo] Hello, forum and admin!');
});